import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { PLS_GAME_INFO_CHANNELS } from '@bg-shared/constants/socketChannels';
import { IGameBlackjackDraw } from '@bg-shared/interfaces/Draws/IBlackjackDraw';
import { IPLSGameId } from '@bg-shared/interfaces/GameId';
import { gameBlackjackStore } from './GameBlackjack.store';

export default class GameBlackjackEvents {
    public configure(gameId: IPLSGameId): void {
        webSocketsRepository.on<IGameBlackjackDraw>(PLS_GAME_INFO_CHANNELS[gameId], (data) => {
            gameBlackjackStore.updateGame(gameId, data);
        });
    }
}

export const gameBlackjackEvents = new GameBlackjackEvents();
